import { getSelectionListContext } from '@dixa/lib-shared-habla';
import { effects } from '@dixa/lib-shared-tokens';
import type { Tag } from 'lib-shared-types-api';
import { useContext, useEffect } from 'react';

import { tagsApi } from 'apis/tags';
import { getFavoriteItemLayoutContext } from 'components/categorizedList';
import { TagContent } from 'components/tags/tagContent';

/** Represents the tag item content. */
export const TagItemContent = (): JSX.Element => {
  const {
    item: tag,
    isFavorite,
    setFavoriteToggle,
    setIsFavoriteDisabled,
  } = useContext(getFavoriteItemLayoutContext<Tag>());
  const {
    item: { isSelected },
  } = useContext(getSelectionListContext<Tag>());
  const [updateTagFavoriteState] = tagsApi.useUpdateTagFavoriteStateMutation();

  // Handles setting the tag favorite toggle function.
  useEffect(() => {
    setIsFavoriteDisabled(tag.is_deactivated && !isFavorite);
    setFavoriteToggle(() => () => {
      updateTagFavoriteState({ tag, isFavorite: !isFavorite });
    });
  }, [
    tag,
    isFavorite,
    updateTagFavoriteState,
    setFavoriteToggle,
    setIsFavoriteDisabled,
  ]);

  return (
    <TagContent
      tag={tag}
      style={{
        opacity:
          tag.is_deactivated && isSelected(tag)
            ? effects.opacity[500]
            : undefined,
      }}
    />
  );
};
